const Footer = () => {
    return (
        <footer className="footer">
            &copy; AM movie
        </footer>
    )
}

export default Footer;